import { services } from '../../data/services';
import './ServicesList.css';

const ServicesList = () => {
  return (
    <div className="services-list-container">
      {services.map((service, index) => (
        <div key={service.id} className={`services-list-item ${index % 2 === 1 ? 'reverse' : ''}`}>
          <div className="services-list-text">
            <h2>{service.title}</h2>
            <p>{service.description}</p>
          </div>
          {service.image && (
            <div className="services-list-image">
              <img src={service.image} alt={service.title} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ServicesList;
